<div class="history-container">
    <div class="history-row">
        <div class="list-view-item-hover">
            <div class="lvi-content">
                <div class="avatar" [class.danger]="!!opeLog.nbRejet || !!opeLog.nbExclue || !!opeLog.nbErreur">
                    <i class="material-icons-outlined">credit_card</i>
                </div>
                <div class="lvi-body" [class.clickable]="hasErrors" (click)="openErrorList()">
                    <div class="title">
                        <a>
                            <span *ngIf="isReintegration">{{ 'admin.frais.cartes.suivi.lotNumero' | translate }} {{ opeLog.idParent }} - </span>
                            {{ typeLibelle }}
                        </a>
                    </div>
                    <ul class="lvi-attrs">
                        <li>
                            <strong [translate]="'admin.frais.cartes.suivi.numero'"></strong>
                            <span>{{ opeLog.idOpeLog }}</span>
                        </li>
                        <li>
                            <strong [translate]="'admin.frais.cartes.suivi.date'"></strong>
                            <span>{{ opeLog.date | date: 'shortDate' }} {{ opeLog.date | date: 'mediumTime' }}</span>
                        </li>
                        <li>
                            <strong [translate]="'admin.frais.cartes.suivi.nbOpe'"></strong>
                            <span>{{ opeLog.nbOpe }}</span>
                        </li>
                        <li>
                            <strong [translate]="'admin.frais.cartes.suivi.correctes'"></strong>
                            <span>{{ opeLog.nbCorrect }}</span>
                        </li>
                        <li [class.li-danger]="!!opeLog.nbRejet" [nioTooltip]="!!opeLog.nbRejet && ('admin.frais.cartes.suivi.tooltipRejetees' | translate)">
                            <mat-icon *ngIf="!!opeLog.nbRejet" class="material-icons-outlined error-icon">info</mat-icon>
                            <strong [translate]="'admin.frais.cartes.suivi.rejetees'"></strong>
                            <span>{{ opeLog.nbRejet }}</span>
                        </li>
                        <li [class.li-danger]="!!opeLog.nbExclue" [nioTooltip]="!!opeLog.nbExclue && ('admin.frais.cartes.suivi.tooltipExclues' | translate)">
                            <mat-icon *ngIf="!!opeLog.nbExclue" class="material-icons-outlined error-icon">info</mat-icon>
                            <strong [translate]="'admin.frais.cartes.suivi.exclues'"></strong>
                            <span>{{ opeLog.nbExclue }}</span>
                        </li>
                        <li [class.li-danger]="!!opeLog.nbErreur" [nioTooltip]="!!opeLog.nbErreur && ('admin.frais.cartes.suivi.tooltipErreur' | translate)">
                            <mat-icon *ngIf="!!opeLog.nbErreur" class="material-icons-outlined error-icon">info</mat-icon>
                            <strong [translate]="'admin.frais.cartes.suivi.enErreur'"></strong>
                            <span>{{ opeLog.nbErreur }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>